export default __webpack_public_path__ + "static/media/frames_10x10.e16b63aa.jpg";